import * as React from 'react';
import { Select } from '@blueprintjs/select';
import { Category } from '../models/category';
import { Button, MenuItem } from '@blueprintjs/core';
import DataStore from '../data_store';
import { withTranslation, WithTranslation } from 'react-i18next';

const BlueprintSelect = Select.ofType<Category>();

export interface Props extends WithTranslation {
  parent?: Category;
  activeItem?: Category;
  onSelect: (category: Category) => void;
  disabled?: boolean;
}

export function CategoryChildSelect({ parent, activeItem, onSelect, disabled, i18n, t }: Props) {
  const [categories, setCategories] = React.useState<Category[]>([]);

  React.useEffect(() => {
    if (parent?.id) {
      setCategories(DataStore.childCategories(parent.id));
    } else {
      setCategories([]);
    }
  }, [parent?.id]);

  const itemRenderer = (item: Category, options: any) => {
    const name = i18n.language === 'fi' ? item.name_fi : item.name_en;
    return (
      <MenuItem
        key={item.id}
        text={name}
        onClick={options.handleClick}
        active={options.modifiers.active}
      />
    );
  };

  const filterItem = (query: string, item: Category) => {
    const name = i18n.language === 'fi' ? item.name_fi : item.name_en;
    return name.toLowerCase().includes(query.toLowerCase());
  };

  const buttonText = activeItem?.exists
    ? (i18n.language === 'fi' ? activeItem.name_fi : activeItem.name_en)
    : t('subtype');

  const isDisabled = disabled || !parent?.id || categories.length === 0;

  return (
    <BlueprintSelect
      filterable={true}
      disabled={isDisabled}
      items={categories}
      activeItem={activeItem}
      itemRenderer={itemRenderer}
      itemPredicate={filterItem}
      onItemSelect={onSelect}
      popoverProps={{ minimal: true }}
    >
      <Button
        disabled={isDisabled}
        text={buttonText}
        rightIcon="chevron-down"
        fill={true}
      />
    </BlueprintSelect>
  );
}

export default withTranslation()(CategoryChildSelect);
